module.exports = __webpack_public_path__ + "img/info-circle.ad911e8d.svg";